import React from 'react';
import {
  faHeadSideVirus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WindowExclusiveOption = (data) => {
  let career = false;
  let careerText = "Żadnej z usług dodatkowych";
  if (data.parsedData != null) {
    if (data.parsedData.offer != undefined || data.parsedData.offer != null) {
      career = true;
      
      careerText = "Usługę dodatkową: "+ data.careerName;
    }
  }

  const option = [
    { icon: faHeadSideVirus, display: career, text: careerText },
  ];

  const allFalse = option.some(item => item.display === true);

  return (
    <>
      <div className="text-box">
        {allFalse ?
          <div className="title-box1">
            <div className="title-2">Wybrałeś:</div>
          </div> : null}

        {option.map((object) => (
          object.display ? 
          <>
            <div className="description-box-2">
              <div className="text-box">
                <FontAwesomeIcon
                  icon={object.icon}
                  className="choose-icon"
                />
                <div className="choose-text"> {object.text}</div>
              </div>
            </div>
            <br />
          </>
          : null
        ))}

      </div>
    </>
  );
};

export default WindowExclusiveOption;